import { Outlet } from "react-router-dom";
import { QueryProvider } from "./QueryProvider";
import { Frame } from "@shopify/polaris";
import { getShopName } from "../lib/getShopName";
import { useEffect, useRef, useState } from "react";
import { buildUrl } from "../lib/buildUrl";
import { getHost } from "../lib/getHost";
import { isInsideIFrame } from "../lib/isInsideIframe";
import { identifyUser } from "../lib/mixpanel";

export function AppLayout() {
  const shopName = getShopName();
  const host = getHost();
  const authLink = useRef<HTMLAnchorElement>(null);

  const [status, setStatus] = useState({ loading: true, error: "" });

  const authUrl =
    `${process.env.REACT_APP_BACKEND_URL}/shopify/connect?shop=${shopName}&host=${host}` as string;

  useEffect(() => {
    if (!shopName) return;

    fetch(buildUrl(`/stores/${shopName}/check-oauth`), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((resp) => {
        console.log({ resp });
        if (resp.statusCode === 200 && resp.data.shopName) {
          identifyUser(resp.data.id, {
            shopName: resp.data.shopName,
            name: resp.data.name,
            email: resp.data.email,
          });
          // party
          setStatus({ loading: false, error: "" });
        } else if (resp.statusCode === 400) {
          if (isInsideIFrame) {
            authLink.current?.click();
          } else {
            // redirect to auth
            window.location.href = authUrl;
          }
        } else if (resp.error) {
          setStatus({ loading: false, error: resp.error });
          // show error
        }
      });
  }, []);

  if (status.loading) {
    return (
      <>
        <p>Loading...</p>
        <a style={{ opacity: 0 }} ref={authLink} href={authUrl} target="_top">
          Authenticate with Shopify
        </a>
      </>
    );
  }

  if (status.error) {
    return <p>{status.error}</p>;
  }

  return (
    <QueryProvider>
      <Frame>
        <Outlet />
      </Frame>
    </QueryProvider>
  );
}
